import {
  TopNav,
  PageShell,
  Section,
  BackCoverFooter,
} from "./components/brand-scaffold";
import { PlaygroundTypographySection } from "@/design-system/patterns/playground-typography-section";
import { PlaygroundAtomsSection } from "@/design-system/patterns/playground-atoms-section";
import { PlaygroundContainersSection } from "@/design-system/patterns/playground-containers-section";
import { PlaygroundCompositionSection } from "@/design-system/patterns/playground-composition-section";
import { PlaygroundPaletteSection } from "@/design-system/patterns/playground-palette-section";
import { PlaygroundIconsSection } from "@/design-system/patterns/playground-icons-section";
import { PlaygroundBusinessSection } from "@/design-system/patterns/playground-business-section";
import { PlaygroundConsoleSection } from "@/design-system/patterns/playground-console-section";
import { siteHeaderActions, siteNavItems } from "./content";

export default function Playground() {
  return (
    <PageShell>
      <TopNav navItems={siteNavItems} actionItems={siteHeaderActions} homeHref="/" />
      <main className="relative z-10 w-full overflow-hidden pb-32">
        <Section 
          id="playground" 
          eyebrow="PLAYGROUND" 
          title="UI 组件库 & 设计规范" 
          description="【1.0】eyebrow 为页面大标题块顶部的高亮短标签（如 PLAYGROUND / FEATURES），【2.0】title 为主标题，【3.0】description 为副标题说明。这个画廊将所有的 UI 元素和排版进行严格的标号，请直接通过标号来指示修改。">
          
          <div className="flex flex-col gap-24">
            {/* A. 文字排版 */}
            <PlaygroundTypographySection />

            {/* B. 原子级控件 */}
            <PlaygroundAtomsSection />

            {/* C. 容器级组件 */}
            <PlaygroundContainersSection />

            {/* D. 拼接与叠放 */}
            <PlaygroundCompositionSection />

            {/* E. 品牌配色规范 */}
            <PlaygroundPaletteSection />
            
            {/* G. 业务组件 (新增) */}
            <PlaygroundBusinessSection />

            {/* H. Console Mode 原型 */}
            <PlaygroundConsoleSection />
          </div>
        </Section>

        {/* F. 品牌与产品图标 */}
        <Section id="f-icons" eyebrow="F.0" title="ICON SYSTEM" description="Geometric Blueprint Base">
          <PlaygroundIconsSection />
        </Section>

      </main>
      <BackCoverFooter />
    </PageShell>
  );
}
